import { styled } from "styled-components";

import { LevelColors } from "@/interfaces/components";

const Level = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 2rem;
  height: 100%;
  padding: 1rem 0;
`;

const LevelHeader = styled.div`
  width: 100%;

  display: flex;
  justify-content: space-between;
  align-items: center;

  & > p {
    color: ${({ theme }) => theme.colors.black};
    font-size: 1rem;
    font-weight: 600;
    line-height: 140%;
  }
`;

const LevelTextCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const LevelTitle = styled.p`
  color: ${({ theme }) => theme.colors.black};
  font-variant-numeric: stacked-fractions;
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 120%;
  letter-spacing: -0.025rem;
`;

const LevelDescription = styled.p`
  color: ${({ theme }) => theme.colors.secondaryText};
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 140%;
`;

const Header = styled.div`
  margin-top: 2.75rem;

  position: relative;

  display: flex;
  align-items: center;
  align-self: center;
  justify-content: center;

  & > img {
    width: 3.5rem;
    height: 3.5rem;
    z-index: 10;
  }
`;

const LevelOctagon = styled.div<{ $colors: LevelColors }>`
  width: 3.375rem;
  height: 1.375rem;

  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translate(-50%, 0);

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;

  border-radius: 1.25rem;
  border: 2px solid ${({ $colors }) => $colors.border};
  background: ${({ $colors }) => $colors.border};
  box-shadow: 1px 1px 0px 0px ${({ $colors }) => $colors.boxShadow};

  color: ${({ theme }) => theme.colors.black};
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.375rem;
  z-index: 10;
`;

const StarContainer = styled.div<{ $starColor: string }>`
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  position: absolute;

  width: 9rem;
  height: 9rem;
  position: absolute;
  color: ${({ $starColor }) => $starColor};

  animation-name: spin;
  animation-duration: 6s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
`;

const Footer = styled.div`
  display: flex;
  gap: 1.5rem;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  text-align: center;

  padding: 0 1rem;
  & > button {
    width: 100%;
    height: 3rem;
  }
`;

export default {
  Level,
  LevelHeader,
  LevelTextCol,
  LevelTitle,
  LevelDescription,
  Footer,
  Header,
  LevelOctagon,
  StarContainer,
};
